import React, { Component } from 'react';
import ItemsEdit from '../Shared/Items/ItemsNonBooleanDefault';
import { stepExcessesSchema } from '@swa_llow/pricing_engine';
import { DownloadButton } from '../../../../utils/download';
import { UploadArea } from '../../../../utils/upload';

class ExcessesEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upload: false,
        }
        this.uploadedExcesses = this.uploadedExcesses.bind(this);
    }

    uploadedExcesses(results) {
        const { step } = this.props;
        this.setState({ upload: false });
        this.props.updateStep({
            ...step,
            items: results,
        });
    }

    render() {
        const { 
            selected_item_id,
            step,
            inputs,
            is_approved,
            errors,
            version,
        } = this.props;

        const { upload } = this.state;

        const { items = [] } = step;
        const count = items.length;

        return (
            <div>
                <div className="inputs-upload">
                    <div key={`full-buttons`} className="upload-buttons">
                        <button className="button small grey no-hover mr">Count : {count}</button>
                        <DownloadButton 
                            data={{
                                items,
                            }}
                            label={'Excesses'}
                            file_name={`${step.key}.csv`}
                            type={'items'}
                            className={'mr'}
                        />
                        {!is_approved && <button className="button small secondary" onClick={() => this.setState({ upload: !this.state.upload })}>
                            <i className="fa fa-angles-up"></i>Upload Excesses
                        </button>}
                    </div>
                    {upload &&
                        <div className="exclusions-edit">
                            <UploadArea
                                complete={this.uploadedExcesses}
                                type='items' 
                            />
                        </div>
                    }
                </div>
                <ItemsEdit
                    version={version}
                    schema={stepExcessesSchema}
                    set_error={this.props.set_error}
                    updateStep={this.props.updateStep}
                    step={step}
                    inputs={inputs}
                    header={'Excesses'}
                    description={'This section allows you to create quote excesses or deductibles'}
                    tag={'Excess'}
                    is_approved={is_approved}
                    errors={errors}
                    selected_item_id={selected_item_id}
                />
            </div>
        );
    }
}

export default ExcessesEdit;